import { GLOBAL_TAG } from './TOKENS.js';

// Fast helpers
function escapeStr(str) {
  // Order matters: escape ~ first, then .
  let out = "";
  for (let i = 0; i < str.length; i++) {
    const ch = str[i];
    if (ch === "~") out += "~~";
    else if (ch === ".") out += "~d";
    else out += ch;
  }
  // Represent empty strings as ~e to avoid trailing-dot filenames
  return out.length === 0 ? "~e" : out;
}

function unescapeStr(str) {
  let out = "";
  for (let i = 0; i < str.length; i++) {
    const ch = str[i];
    if (ch === "~") {
      const next = str[++i];
      if (next === "~") out += "~";
      else if (next === "d") out += ".";
      else if (next === "e") out += ""; // empty string marker
      else {
        // Unknown escape: treat as literal (robustness)
        out += "~" + (next ?? "");
      }
    } else {
      out += ch;
    }
  }
  return out;
}

export function encodePath(segments) {
  // segments: array of strings or integers
  // Produces: filename/URL-safe string like "sfoo.n0.sbaz"
  const parts = new Array(segments.length);
  for (let i = 0; i < segments.length; i++) {
    const v = segments[i];
    if (typeof v === "number" && Number.isInteger(v)) {
      // 'n' tag
      parts[i] = "n" + String(v); // decimal; includes "-" if negative
    } else if (typeof v === "string") {
      // 's' tag
      parts[i] = "s" + escapeStr(v);
    } else {
      // If you need more types, add here (e.g., booleans 'b', floats 'f').
      throw new TypeError(`Unsupported segment type at index ${i}: ${v}`);
    }
  }
  // Use '.' as separator (safe in URLs and filenames; we avoid trailing '.')
  return parts.join(".");
}

export function decodeAddress(address) {
  if (address === GLOBAL_TAG) return GLOBAL_TAG;
  if (address.length === 0) return [];
  const raw = address.split(".");
  const out = new Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    const token = raw[i];
    if (token.length === 0) {
      // Disallow empty tokens (would imply trailing or double dots)
      throw new Error("Invalid address: empty token");
    }
    const tag = token[0];
    const body = token.slice(1);
    if (tag === "n") {
      // Fast parse (no regex)
      if (body.length === 0 || !/^[-]?\d+$/.test(body)) {
        throw new Error(`Invalid numeric token: "${token}"`);
      }
      const num = Number(body);
      // Ensure it was an integer
      if (!Number.isInteger(num)) {
        throw new Error(`Non-integer numeric token: "${token}"`);
      }
      out[i] = num;
    } else if (tag === "s") {
      out[i] = unescapeStr(body);
    } else {
      throw new Error(`Unknown type tag "${tag}" in token "${token}"`);
    }
  }
  return out;
}
